import axios from 'axios';
let instance = axios.create({
	baseURL: `${process.env.REACT_APP_BACKEND_PRODUCTION_API_URL}`,
	timeout: 1000000,
});

if (process.env.NODE_ENV === 'development') {
	instance = axios.create({
		baseURL: `${process.env.REACT_APP_BACKEND_DEV_API_URL}`,
		timeout: 1000000,
	});
}

export default instance;
